import axios from 'axios'
import { store } from '../store'

const TOKEN_KEY = 'loginToken'
const REFRESH_TOKEN_KEY = 'refresh_token'
const USERNAME = 'username'
const ROLES = 'roles'

/**
 * Manage the how Access Tokens are being stored and retrieved from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instance.
**/
const TokenService = {
  loadedMeetings: false,
  loadedPhotoshoots: false,
  loadedGalleries: false,

  getToken () {
    return localStorage.getItem(TOKEN_KEY)
  },

  saveToken (accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken)
  },

  removeToken () {
    localStorage.removeItem(TOKEN_KEY)
  },

  // TODO: change NCPS login to use tokens
  getUsername () {
    return localStorage.getItem(USERNAME)
  },

  removeRoles () {
    localStorage.removeItem(ROLES)
  },

  loadNewsletters (forceReload) {
    if( this.loadedMeetings && !forceReload ) {
      return
    }
    axios({ method: 'GET',
      'url': process.env.VUE_APP_WEBSITE + '/memberlogin2/api_listmeetings.php?JSON=true&listAll=true&Username=' + this.getUsername() + '&token=' + this.getToken()
    }).then(result => {
      this.loadedMeetings = true
      var meetings = []
      result.data.meetings.forEach(element => {
        element.id = ''+element.id
        meetings.push(element)
      })
      store.commit('setMeetings', meetings)
    }, error => {
      this.error = error
      // console.error(error)
    })
  },

  loadPhotoshoots (forceReload) {
    if( this.loadedPhotoshoots && !forceReload ) {
      return
    }
    axios({ method: 'GET',
      'url': process.env.VUE_APP_WEBSITE + '/memberlogin2/api_listphotoshoots.php'
    }).then(result => {
      this.loadedPhotoshoots = true
      var photoshoots = []
      result.data.forEach(element => {
        element.type = 'photoshoot'
        photoshoots.push(element)
      })
      store.commit('setPhotoshoots', photoshoots)
    }, error => {
      console.error(error)
    })
  },

  loadGalleries (forceReload) {
    if( this.loadedGalleries && !forceReload ) {
      return
    }
    store.commit('setUserHasGallery', true)
    axios({ method: 'GET',
      'url': process.env.VUE_APP_WEBSITE + '/memberlogin2/api_listgalleries.php?withData=true'
    }).then(result => {
      store.commit('setUserHasGallery', false)
      this.loadedGalleries = true
      var galleries = []
      result.data.forEach(element => {
        // sort member's gallery to top
        // TODO: was ===, but I think userID doesn't match because it's a string vs number when compared to login value
        // eslint-disable-next-line
        if (element.userID == store.state.memberInfo.userID) {
          galleries.splice(0, 0, element)
          store.commit('setUserHasGallery', true)
        } else {
          galleries.push(element)
        }
      })
      store.commit('setGalleries', galleries)
    }, error => {
      console.error(error)
    })
  },

  loadMeetingInfo () {
    axios({ method: 'GET',
      'url': process.env.VUE_APP_WEBSITE + '/memberlogin2/api_meetingInfo.php'
    }).then(result => {
      result.data.meetingDate = result.data.meetingdate
      result.data.randomGalleryImage = process.env.VUE_APP_WEBSITE + result.data.randomGalleryImage
      result.data.image = process.env.VUE_APP_WEBSITE + '/meeting/' + result.data.meetingDate.substring(0, 7) + '/speaker_01.jpg'
      store.commit('setMeetingInfo', result.data)
    }, error => {
      console.error(error)
    })
  },

  saveMemberInfo (newPassword) {
    var params = new URLSearchParams()
    params.append('userID', store.state.memberInfo.userID)
    params.append('secondUserID', store.state.memberInfo.secondUserID)
    params.append('adminUsername', TokenService.getUsername())
    params.append('token', TokenService.getToken())
    params.append('galleryDesc', store.state.memberInfo.galleryDesc)
    params.append('galleryDesc2', store.state.memberInfo.galleryDesc2)
    params.append('lastName', store.state.memberInfo.lastName)
    params.append('lastName2', store.state.memberInfo.lastName2)
    params.append('firstName', store.state.memberInfo.firstName)
    params.append('firstName2', store.state.memberInfo.firstName2)
    params.append('city', store.state.memberInfo.city)
    params.append('wantsEmail', store.state.memberInfo.wantsEmail)
    params.append('revealEmail', store.state.memberInfo.revealEmail)
    params.append('revealEmail2', store.state.memberInfo.revealEmail2)
    params.append('duesPaid', store.state.memberInfo.duesPaid)
    params.append('address', store.state.memberInfo.address)
    params.append('state', store.state.memberInfo.state)
    params.append('email', store.state.memberInfo.email)
    params.append('areaCode1', store.state.memberInfo.areaCode1)
    params.append('areaCode2', store.state.memberInfo.areaCode2)
    params.append('duesExpire', store.state.memberInfo.duesExpire)
    params.append('zip', store.state.memberInfo.postalcode)
    params.append('website', store.state.memberInfo.website)
    params.append('num', store.state.memberInfo.num)
    params.append('wantsUSPS', store.state.memberInfo.wantsUSPS)
    if (newPassword !== '') {
      params.append('newPassword', newPassword)
    }
    params.append('homePhone', store.state.memberInfo.homePhone)
    params.append('workPhone', store.state.memberInfo.workPhone)
    params.append('newUsername', store.state.memberInfo.username)
    params.append('speaker', store.state.memberInfo.speaker)
    params.append('frozen', store.state.memberInfo.frozen)
    axios.post(process.env.VUE_APP_WEBSITE + '/memberlogin2/api_savechanges.php', params).then(result => {
      this.result = result
      // self.$emit('close-dialog')
    }, error => {
      alert(error)
    })
  },

  parseBannerImages (bannerimages) {
    var parsedImages = {};
    bannerimages.forEach(element => {
      var item = {url:element.url, copyright:element.copyright, textcolor:element.textcolor, gradient:element.gradient, id:element.id}
      parsedImages[element.tabname] = item
    })
    store.commit('setBanners', parsedImages)
  },

  refreshLogin () {
    // if (!store.state.loggedIn) {
    var username = localStorage.getItem('username')
    var token = TokenService.getToken()

    var bodyFormData = new FormData()
    bodyFormData.append('Username', username)
    bodyFormData.append('token', token)
    bodyFormData.append('JSON', 'true')
    axios.post(process.env.VUE_APP_WEBSITE + '/memberlogin2/api_login.php', bodyFormData)
    .then(response => {
      this.parseBannerImages(response.data.bannerimages)
      if (response.data.error === 'Wrong username or password') {
        store.commit('setLoggedIn', false)
      } else {
        store.commit('setLoggedIn', true)
        store.commit('setRoles', response.data.roles)
        store.commit('setMemberInfo', response.data)
        store.commit('setMemberName', response.data.firstName + ' ' + response.data.lastName)
      }
    })
    .catch(error => {
      this.parseBannerImages(error.response.data.bannerimages)
      store.commit('setLoggedIn', false)
    })
  }
  // }
}

export { TokenService }
